// class AudioService {
//   constructor() {
//     this.currentAudio = null;
//     this.isAudioPlaying = false;
//   }
//   playAudio(audioUrl) {
//     this.currentAudio?.pause();
//     if (audioUrl) {
//       this.currentAudio = new Audio(audioUrl);
//       this.isAudioPlaying = true;
//       this.currentAudio.play().catch(console.error).finally(() => {
//         this.isAudioPlaying = false;
//       });
//     }
//   }

//   playLocalAudio(fileName) {
//     const audioPath = `${process.env.PUBLIC_URL}/audio/${fileName}`;
//     this.playAudio(audioPath);
//   }
// }

// export const audioService = new AudioService();

// class AudioService {
//   constructor() {
//     this.currentAudio = null;
//     this.isAudioPlaying = false;
//   }

//   playAudio(audioUrl) {
//     // Stop current audio if playing
//     this.stopAudio();

//     if (audioUrl) {
//       this.currentAudio = new Audio(audioUrl);
//       this.setupAudioEventListeners();

//       this.currentAudio
//         .play()
//         .then(() => {
//           this.isAudioPlaying = true;
//         })
//         .catch((error) => {
//           console.error("Audio playback failed:", error);
//           this.isAudioPlaying = false;
//         });
//     }
//   }

//   playLocalAudio(fileName) {
//     // Use relative path or configure base path as needed
//     const audioPath = `${process.env.PUBLIC_URL}/audio/${fileName}`;
//     // Alternative: const audioPath = `${window.location.origin}/audio/${fileName}`;
//     this.playAudio(audioPath);
//   }

//   stopAudio() {
//     if (this.currentAudio) {
//       this.currentAudio.pause();
//       this.currentAudio.currentTime = 0;
//       this.removeAudioEventListeners();
//       this.isAudioPlaying = false;
//     }
//   }

//   pauseAudio() {
//     if (this.currentAudio && this.isAudioPlaying) {
//       this.currentAudio.pause();
//       this.isAudioPlaying = false;
//     }
//   }

//   resumeAudio() {
//     if (this.currentAudio && !this.isAudioPlaying) {
//       this.currentAudio
//         .play()
//         .then(() => {
//           this.isAudioPlaying = true;
//         })
//         .catch((error) => {
//           console.error("Audio resume failed:", error);
//         });
//     }
//   }

//   setupAudioEventListeners() {
//     if (!this.currentAudio) return;

//     this.currentAudio.addEventListener(
//       "ended",
//       this.handleAudioEnded.bind(this)
//     );
//     this.currentAudio.addEventListener(
//       "pause",
//       this.handleAudioPaused.bind(this)
//     );
//     this.currentAudio.addEventListener(
//       "error",
//       this.handleAudioError.bind(this)
//     );
//   }

//   removeAudioEventListeners() {
//     if (!this.currentAudio) return;

//     this.currentAudio.removeEventListener(
//       "ended",
//       this.handleAudioEnded.bind(this)
//     );
//     this.currentAudio.removeEventListener(
//       "pause",
//       this.handleAudioPaused.bind(this)
//     );
//     this.currentAudio.removeEventListener(
//       "error",
//       this.handleAudioError.bind(this)
//     );
//   }

//   handleAudioEnded() {
//     this.isAudioPlaying = false;
//     this.removeAudioEventListeners();
//   }

//   handleAudioPaused() {
//     this.isAudioPlaying = false;
//   }

//   handleAudioError(error) {
//     console.error("Audio error:", error);
//     this.isAudioPlaying = false;
//     this.removeAudioEventListeners();
//   }

//   // Getter for current playing state
//   get playing() {
//     return this.isAudioPlaying;
//   }

//   // Cleanup method for when service is no longer needed
//   destroy() {
//     this.stopAudio();
//     this.currentAudio = null;
//   }
// }

// export const audioService = new AudioService();


class AudioService {
  constructor() {
    this.currentAudio = null;
    this.isAudioPlaying = false;
    this.stateChangeListeners = new Set(); // For React state updates

    this.boundHandleAudioEnded = this.handleAudioEnded.bind(this);
    this.boundHandleAudioPaused = this.handleAudioPaused.bind(this);
    this.boundHandleAudioError = this.handleAudioError.bind(this);
  }

  // Add listener for state changes
  addStateChangeListener(callback) {
    this.stateChangeListeners.add(callback);
  }

  // Remove listener
  removeStateChangeListener(callback) {
    this.stateChangeListeners.delete(callback);
  }

  // Notify all listeners when state changes
  notifyStateChange() {
    this.stateChangeListeners.forEach((callback) => {
      callback(this.isAudioPlaying);
    });
  }

  playAudio(audioUrl) {
    this.stopAudio();

    if (audioUrl) {
      this.currentAudio = new Audio(audioUrl);
      this.setupAudioEventListeners();

      this.currentAudio
        .play()
        .then(() => {
          this.isAudioPlaying = true;
          this.notifyStateChange(); // Notify React components
        })
        .catch((error) => {
          console.error("Audio playback failed:", error);
          this.isAudioPlaying = false;
          this.notifyStateChange(); // Notify React components
        });
    }
  }

  playLocalAudio(fileName) {
    const audioPath = `/audio/${fileName}`;
    this.playAudio(audioPath);
  }

  stopAudio() {
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
      this.removeAudioEventListeners();
      this.currentAudio = null; // Clean up reference
      this.isAudioPlaying = false;
      this.notifyStateChange(); // Notify React components
    }
  }

  pauseAudio() {
    if (this.currentAudio && this.isAudioPlaying) {
      this.currentAudio.pause();
      this.isAudioPlaying = false;
      this.notifyStateChange(); // Notify React components
    }
  }

  resumeAudio() {
    if (this.currentAudio && !this.isAudioPlaying) {
      this.currentAudio
        .play()
        .then(() => {
          this.isAudioPlaying = true;
          this.notifyStateChange(); // Notify React components
        })
        .catch((error) => {
          console.error("Audio resume failed:", error);
          this.isAudioPlaying = false;
          this.notifyStateChange(); // Notify React components on error
        });
    }
  }

  setupAudioEventListeners() {
    if (!this.currentAudio) return;

    this.currentAudio.addEventListener("ended", this.boundHandleAudioEnded);
    this.currentAudio.addEventListener("pause", this.boundHandleAudioPaused);
    this.currentAudio.addEventListener("error", this.boundHandleAudioError);
  }

  removeAudioEventListeners() {
    if (!this.currentAudio) return;

    this.currentAudio.removeEventListener("ended", this.boundHandleAudioEnded);
    this.currentAudio.removeEventListener("pause", this.boundHandleAudioPaused);
    this.currentAudio.removeEventListener("error", this.boundHandleAudioError);
  }

  handleAudioEnded() {
    this.isAudioPlaying = false;
    this.removeAudioEventListeners();
    this.currentAudio = null; // Clean up reference
    this.notifyStateChange(); // Notify React components
  }

  handleAudioPaused() {
    // Only update if we haven't already handled this pause in our methods
    if (this.isAudioPlaying) {
      this.isAudioPlaying = false;
      this.notifyStateChange(); // Notify React components
    }
  }

  handleAudioError(error) {
    console.error("Audio error:", error);
    this.isAudioPlaying = false;
    this.removeAudioEventListeners();
    this.currentAudio = null; // Clean up reference
    this.notifyStateChange(); // Notify React components
  }

  get playing() {
    return this.isAudioPlaying;
  }

  destroy() {
    this.stopAudio();
    this.stateChangeListeners.clear();
  }
}

export const audioService = new AudioService();
